// Who is notified when a client submits onboarding (Plan 5 decision 1): Collin and Chris, plus the
// PM and account owner (or oversight) of every live project: not archived, not yet ended.
import { isEmail } from "../meetings/recipients.js";

const FIXED = ["collin@sawtoothadvisors.io", "chris@sawtoothadvisors.io"];
const norm = (s) => String(s || "").trim().toLowerCase();

export function notificationRecipients({ projects, users, today }) {
  const out = [];
  const add = (a) => { const n = norm(a); if (isEmail(n) && !out.includes(n)) out.push(n); };
  FIXED.forEach(add);
  const resolve = (v) => {
    if (!v) return null;
    const u = (users || []).find((x) => x.id === v || norm(x.email) === norm(v));
    return u ? u.email : isEmail(v) ? v : null;
  };
  for (const p of projects || []) {
    if (p.archivedAt || (p.endDate && p.endDate < today)) continue;
    add(resolve(p.projectManager));
    add(resolve(p.accountOwner ?? p.projectOversight));
  }
  return out;
}
